import { render, staticRenderFns } from "./exception-list.vue?vue&type=template&id=40507ff6"
import script from "./exception-list.vue?vue&type=script&lang=js"
export * from "./exception-list.vue?vue&type=script&lang=js"
import style0 from "./exception-list.vue?vue&type=style&index=0&id=40507ff6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports